import { render } from "./OrdersComponent.vue?vue&type=template&id=36c0b93a"
import script from "./OrdersComponent.vue?vue&type=script&lang=js"
export * from "./OrdersComponent.vue?vue&type=script&lang=js"

import "./OrdersComponent.vue?vue&type=style&index=0&id=36c0b93a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__